import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { AccountDetails } from "./AccountDetails";
import { Accounts } from "./Accounts";
import { ContactDetails } from "./ContactDetails";
import { ContractDetails } from "./ContractDetails";

export const ACCOUNT_ID_PARAM = "accountId";
export const CONTRACT_ID_PARAM = "contractId";
export const CONTACT_ID_PARAM = "contactId";

export const ACCOUNT_ROUTES = {
  base: "/accounts",
  details: "/:accountId",
  contactsList: "/:accountId/contacts",
  contractsList: "/:accountId/contracts",
  contactDetails: `/:${ACCOUNT_ID_PARAM}/contacts/:${CONTACT_ID_PARAM}`,
  contractDetails: `/:${ACCOUNT_ID_PARAM}/contracts/:${CONTRACT_ID_PARAM}`,
} as const;

export function AccountRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}${ACCOUNT_ROUTES.contactDetails}`}>
        <ContactDetails />
      </Route>
      <Route path={`${path}${ACCOUNT_ROUTES.contractDetails}`}>
        <ContractDetails />
      </Route>
      <Route path={`${path}${ACCOUNT_ROUTES.details}`}>
        <AccountDetails />
      </Route>
      <Route exact path={path}>
        <Accounts />
      </Route>
    </Switch>
  );
}
